import * as yup from 'yup';
import moment from 'moment';

export const directPaymentSchema = yup.object().shape({
  amount: yup.string().nullable().required('Please provide payment amount.'),
  year: yup.string().nullable().required('Please enter a tax year.'),
  paymentDate: yup
    .date()
    .transform((_value, originalValue) => {
      const parsedValue = moment(originalValue, 'M/D/YYYY', true);

      // if it's valid return the date object, otherwise return an `InvalidDate`
      return parsedValue.isValid() ? parsedValue.toDate() : new Date('');
    })
    .typeError('Please enter a date of payment in MM/DD/YYYY.'),
});
